import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=14b95215&scoped=true"
import script from "./DepartmentList.vue?vue&type=script&lang=ts"
export * from "./DepartmentList.vue?vue&type=script&lang=ts"
import style0 from "./DepartmentList.vue?vue&type=style&index=0&id=14b95215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b95215",
  null
  
)

export default component.exports